import type React from 'react';

function HelthjemIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 220.62 220.62"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Helthjem Icon</title>
      <defs>
        <g id="mask-4">
          <polygon
            id="path-3"
            points="34.11 1.23 195.19 1.23 195.19 218.55 34.11 218.55 34.11 1.23"
            fill="#fff"
          />
        </g>

        <g id="mask-4-2" data-name="mask-4">
          <polygon
            id="path-3-2"
            data-name="path-3"
            points="34.11 1.23 195.19 1.23 195.19 218.55 34.11 218.55 34.11 1.23"
            fill="#fff"
          />
        </g>
      </defs>

      <g id="Layer_1-2" data-name="Layer 1">
        <path
          id="Fill-11"
          d="M119.72,97.39L33.9,63.21c-2.51-1-5.38,.81-5.38,3.65v61.57c0,1.61,.98,3.06,2.48,3.65l85.81,33.98c2.55,1.01,5.37-.86,5.37-3.65v-61.37c0-1.61-.98-3.05-2.47-3.65"
          fill="inherit"
        />

        <path
          id="Fill-12"
          d="M119.72,173.46l-49.24-19.59c-2.72-1.04-5.38,.99-5.38,3.65v37.91c0,1.62,1,3.08,2.52,3.66l49.24,18.89c2.55,.98,5.33-.89,5.33-3.67v-37.22c0-1.61-.98-3.05-2.48-3.65"
          fill="inherit"
        />

        <path
          id="Fill-13"
          d="M56.35,148.38l-22.45-8.94c-2.63-1.05-5.38,.92-5.38,3.65v37.91c0,1.61,.98,3.05,2.47,3.65l22.44,8.95c2.51,.99,5.38-.81,5.38-3.65v-37.91c0-1.61-.98-3.05-2.47-3.65"
          fill="inherit"
        />

        <g id="Group-17" transform="translate(5.000000, 0.000000)">
          <path
            id="Fill-14"
            d="M189.4,66.52l-58.87,31.57c-1.28,.68-2.07,2.01-2.07,3.46v113.08c0,3.03,3.24,4.82,5.78,3.46l58.87-31.57c1.27-.69,2.07-2.01,2.07-3.46V69.98c0-2.97-3.17-4.86-5.78-3.46"
            fill="#3f4240"
          />

          <path
            id="Fill-16"
            d="M166,31.78L81.36,1.52c-1.63-.65-3.49-.15-4.56,1.24L34.94,51.93c-1.47,1.72-1.03,4.98,1.64,6.05l85.81,34.52c1.8,.72,3.66-.05,4.59-1.26l40.77-53.4c1.7-2.22,.55-5.24-1.74-6.06"
            fill="#3f4240"
          />
        </g>
        <rect width="220.62" height="220.62" fill="none" />
      </g>
    </svg>
  );
}

export default HelthjemIcon;
